<div class="input-group relative">
  <ng-template
    #dayTemplate
    let-currentMonth="currentMonth"
    let-date
    let-focused="focused"
    let-selected="selected"
    let-today="today"
  >
    <span
      class="relative inline-flex h-6 w-6 items-center justify-center rounded-full text-sm hover:bg-primary-300 hover:text-secondary"
      [ngClass]="{
        'text-secondary-300': isOutsideMonth(date, currentMonth) || isWeekend(date),
        'bg-primary-400 font-bold': today,
        'text-white': selected || today,
        'bg-primary-500': selected
      }"
    >
      {{ date.day }}
    </span>
  </ng-template>
  <input
    type="text"
    [id]="inputId"
    class="form-control pr-8"
    [ngClass]="{ 'is-invalid': formControlRef.invalid && formControlRef.touched }"
    autocomplete="off"
    [placeholder]="placeholder"
    [formControl]="formControlRef"
    ndtDatepicker
    [datepickerClass]="'ndt'"
    [dayTemplate]="dayTemplate"
    [footerTemplate]="footerTemplate"
    [maxDate]="maximumDate"
    [minDate]="minimumDate"
    #datepicker="ndtDatepicker"
  />

  <ng-template #otworz i18n>Otwórz kalendarz</ng-template>
  <button
    ndt-icon-button
    type="button"
    class="absolute right-0 top-1 z-10 pr-2"
    [disabled]="formControlRef.disabled"
    [ngbTooltip]="otworz"
    (click)="datepicker.toggle()"
  >
    <app-icon name="calendar"></app-icon>
  </button>
  <span class="invalid-feedback">
    <ng-container i18n *ngIf="formControlRef.hasError('required')">To pole jest wymagane.</ng-container>
    <ng-container
      i18n
      *ngIf="
        !!formControlRef.errors?.ngbDate?.invalid && !formControlRef.hasError('required') && !!formControlRef.value
      "
    >
      Wprowadzona wartość jest nieprawidłowa.</ng-container
    >
    <ng-container
      *ngIf="
        !!formControlRef.errors?.ngbDate?.maxDate && !formControlRef.hasError('required') && !!formControlRef.value
      "
    >
      <ng-container i18n>Maksymalna data to</ng-container>
      {{ maximumDate.year + '-' + maximumDate.month + '-' + maximumDate.day }}.</ng-container
    >
    <ng-container
      *ngIf="
        !!formControlRef.errors?.ngbDate?.minDate && !formControlRef.hasError('required') && !!formControlRef.value
      "
    >
      <ng-container i18n>Minimalna data to</ng-container>
      {{ minimumDate.year + '-' + minimumDate.month + '-' + minimumDate.day }}.</ng-container
    >
    <ng-content [select]="feedback"></ng-content>
  </span>
</div>

<ng-template #footerTemplate>
  <div class="flex justify-between bg-neutral-100 px-4 py-2">
    <button
      ndt-tertiary-button
      type="button"
      [disabled]="formControlRef.disabled || !formControlRef.value"
      (click)="clear(); datepicker.close()"
      i18n
    >
      Wyczyść
    </button>
    <button
      ndt-tertiary-button
      type="button"
      [disabled]="formControlRef.disabled"
      (click)="setToday(); datepicker.close()"
      i18n
      >Dzisiaj</button
    >
  </div>
</ng-template>
